<template>
  <el-container class="h-full relative" v-loading="loading">
    <control-aside @add="onAdd" />
    <el-main class="p-0 edit relative bg-bg-common-color edit-container" style="min-width:1000px;overflow-x: hidden;">
      <div class="pr-6 overflow-y-auto">
        <div class="question-group">
          <control-question
            v-for="item in questionList"
            :key="item.q_id"
            :question="item"
            @update="onUpdate(item)"
            @remove="onRemove(item)"
            @copy="onCopy(item)"
            @success="onSuccess"
            :disabledChangeQuestion="disabledChangeQuestion"
          ></control-question>
        </div>
      </div>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="my-2 fixed bottom-0" style="left: 470px" v-custom:more-app-control-lib="'out_D33_D'" />
    </el-main>
    <el-aside class="absolute-right edit-setting-aside" width="290" @click.native.stop>
      <el-scrollbar class="h-full" wrap-class="overflow-x-hidden">
        <control-setting @update="onUpdate" />
      </el-scrollbar>
    </el-aside>
  </el-container>
</template>

<script>
import { deleteControlQuestion, getControlList, updateControlQuestion } from '@/api/control-lib'
import { convertQuestion, createQuestion, normalizeNum } from '@/question/factory'
import { surveyLoading } from '@/assets/js/el-loading'
import ControlAside from '@/views/control-lib/ControlAside'
import ControlSetting from '@/views/control-lib/ControlSetting'
import { Type } from '@/assets/js/code'
import { SET_SELECT_QUESTION } from '@/store/survey/mutation-types'
import ControlQuestion from '@/views/control-lib/ControlQuestion'
import cloneDeep from 'lodash/cloneDeep'
import DygcFooter from 'components/dygc-footer-bottom/index'

export default {
  name: 'ControlLib',
  components: { ControlQuestion, ControlSetting, ControlAside, DygcFooter },
  data() {
    return {
      questionList: [],
      loading: false,
      disabledChangeQuestion: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      getControlList()
        .then(list => {
          const questionList = list.map(convertQuestion)
          normalizeNum(questionList)
          this.questionList = questionList
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onCopy(item) {
      console.log('item', item)
      if (this.questionList.some(it => it.id === null)) {
        this.$message.warning('请先设置正确答案')
        return
      } else {
        createQuestion(item.question_type).then(question => {
          question.type = Type.CONTROL
          question.issue.items = item.issue.items
          this.questionList.push(cloneDeep(question))
          this.disabledChangeQuestion = true
          this.removeBusHandler()
          this.removeBusHandler = this.disabledPageHandler()
          this.$store.commit(SET_SELECT_QUESTION, question)
        })
      }
    },
    onAdd(item) {
      if (this.disabledChangeQuestion) return
      this.disabledChangeQuestion = true
      createQuestion(item.value).then(question => {
        question.type = Type.CONTROL
        this.$store.commit(SET_SELECT_QUESTION, question)
        this.questionList.push(question)
        this.removeBusHandler()
        this.removeBusHandler = this.disabledPageHandler()
      })
    },
    onUpdate(question) {
      if (!question.id) return
      surveyLoading(() => {
        return updateControlQuestion(question.getParams())
      })
    },
    onRemove(question) {
      // this.$confirm('确定要删除吗？', '删除题目确认', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   cancelButtonClass: 'normal-button',
      //   confirmButtonClass: 'normal-button'
      // }).then(() => {
      const index = this.questionList.findIndex(q => q.q_id === question.q_id)
      this.$store.commit(SET_SELECT_QUESTION, null)
      if (question.id) {
        deleteControlQuestion(question.id).then(res => {
          this.questionList.splice(index, 1)
        })
      } else {
        this.questionList.splice(index, 1)
        this.onSuccess()
      }
      // })
    },
    onSuccess() {
      this.disabledChangeQuestion = false
      this.removeBusHandler()
      this.removeBusHandler = this.initBusHandler()
    },

    initBusHandler() {
      const clickWindowHandler = () => {
        this.$store.commit(SET_SELECT_QUESTION, null)
      }
      window.addEventListener('click', clickWindowHandler)
      return function () {
        window.removeEventListener('click', clickWindowHandler)
      }
    },
    disabledPageHandler() {
      const clickWindowHandler = () => {
        this.$message.warning('请先设置正确答案')
      }
      window.addEventListener('click', clickWindowHandler)
      return function () {
        window.removeEventListener('click', clickWindowHandler)
      }
    }
  }
}
</script>
